import { DbLoadTransfer } from "../../../data/usecases/load-transfer";
import { LoadTransfer } from "../../../domain/usecases/load-transfer";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbLoadTransfer = (): LoadTransfer =>
  new DbLoadTransfer(
    makeApiUrl("/transfer"),
    makeAuthorizeHttpClientDecorator()
  );
